import { Component, ViewChild, ElementRef, Input, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Chart } from 'chart.js/auto';

@Component({
    selector: 'app-ltms-doughnut-chart-view',
    templateUrl: './ltms-doughnut-chart-view.component.html',
    styleUrls: ['./ltms-doughnut-chart-view.component.scss'],
    standalone: true
})

export class LtmsDoughnutChartViewComponent implements OnInit, AfterViewInit { 
  @ViewChild('chartCanvas', { static: true }) chartCanvas!: ElementRef<HTMLCanvasElement>;
  @Input() chartData: any = []
  @Input() colors: any = ['#0A7139', '#F8B415', '#EC2524']
  @Input() elementId: string = ""
  private chartInstance: Chart | any;
  data: number[] = [];
  canvasId:string="ltms-doughnut-chart";
  doughnutLine: any = {
    id: 'doughnutLine',
    afterDraw(chart, args, options) {
      const { ctx, chartArea: { width, height } } = chart;
      chart.data.datasets.forEach((dataset, i) => {
        chart.getDatasetMeta(i).data.forEach((datapoint) => {
          const halfwidth = width / 2;
          const halfheight = height / 2;
          const { x, y } = datapoint.tooltipPosition();
          ctx.beginPath();
          ctx.moveTo(x, y);
          const xLine = x >= halfwidth ? x + 30 : x - 30;
          const yLine = y >= halfheight ? y + 30 : y - 30;
          const extraLine = x >= halfwidth ? 60 : -60;
          ctx.lineTo(xLine, yLine);
          ctx.strokeStyle = '#000000';
          ctx.stroke();
          ctx.beginPath();
          ctx.moveTo(xLine, yLine);
          ctx.lineTo(xLine + extraLine, yLine);
          ctx.strokeStyle = '#000000';
          ctx.stroke();
        }); 
      });
    }
  };

   
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.initChart()
    this.cdr.detectChanges();
  }

  ngOnChanges() {
    this.initChart()
  }

  initChart() {
    this.data = this.chartData;
    this.showChart();
  }

  private generateRandomId(): string {
    return 'chart-' + Math.random().toString(36).substr(2, 9);
  }


  private showChart(): void {
    this.destroyChart();
    const ctx = this.chartCanvas.nativeElement.getContext('2d');
    const tooltipElement = document.getElementById(this.elementId + '-tooltip') as HTMLDivElement;
    const tooltipContent = document.getElementById(this.elementId + '-tooltip-content') as HTMLParagraphElement;
    const formatNumber = (num: number): string => {
      if (num >= 1_000_000) {
        return (num / 1_000_000).toFixed(1) + 'M';
      } else if (num >= 1_000) {
        return (num / 1_000).toFixed(1) + 'K'; 
      }
      return num.toString(); 
    };
    const formatIndianNumber =(num:number): string => {
      var numStr = num.toString();
      var lastThree = numStr.substring(numStr.length - 3);
      var otherNumbers = numStr.substring(0, numStr.length - 3);
      
      if (otherNumbers != '') {
          lastThree = ',' + lastThree;
      }
      
      var result = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
      return result;
  }
    
    if (ctx) {
      const labels = this.chartData.map(item => item.key);  // Extract labels
      const data = this.chartData.map(item => item.value);  // Extract data values
      const totalValue = data.reduce((acc, item) => acc + item, 0);

      this.chartInstance = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [
            {
              data: data,
              backgroundColor: this.colors,
              borderWidth: 0,
              hoverBackgroundColor: this.colors
            },
          ],
        },
        options: {
          responsive: true,
          hover: {
            mode: 'nearest', // Use a valid mode; 'nearest' is the most neutral
          },
          cutout: '60%',
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              enabled: false, // Disable the default tooltip,
              // position: "nearest",
              external: function(context) {
                const tooltipModel = context.tooltip;
                // Check if tooltip is active (show only on hover)
                if (tooltipModel.opacity === 0) {
                  tooltipElement.style.display = 'none'; // Hide tooltip when no item is hovered
                  return;
                }

                // Set position for the tooltip
                // const position = tooltipModel.caretX + 'px';
                // tooltipElement.style.left = position;
                // tooltipElement.style.top = tooltipModel.caretY + 'px';

                // Format the tooltip content
                const tooltipLabel = tooltipModel.dataPoints[0]?.label || '';
                const tooltipValue = tooltipModel.dataPoints[0]?.raw || '';
                const numberValue = !isNaN(Number(tooltipValue)) ? Number(tooltipValue) : 0;
                const percentage = totalValue > 0 ? ((numberValue / totalValue) * 100).toFixed(1) : 0;
                
                tooltipContent.innerHTML = `
                <div style="display: flex; justify-content: space-between; white-space: nowrap;">
                <span style="
                  text-align: left;
                  font: 900 16px Lato;
                  letter-spacing: 0.18px;
                  color: #000000;
                  opacity: 1;
                  padding-right: 20px;
                ">${tooltipLabel}</span>
                <span style="
                  text-align: right;
                  font: 16px Lato;
                  letter-spacing: 0.18px;
                  color: #000000;
                  opacity: 1;
                ">${formatIndianNumber(numberValue)} (${percentage}%)</span>
                </div>
              `;
                // Show the tooltip div
                tooltipElement.style.display = 'block';
              }
            }
          },
          onHover: (event, elements) => {
            if (elements.length) {
              this.chartCanvas.nativeElement.style.cursor = 'default';
              const tooltipWidth = tooltipElement.offsetWidth || tooltipElement.getBoundingClientRect().width;
              // console.log("Tooltip width:", tooltipWidth);
              const mouseEvent = event.native as MouseEvent;
              const canvasPosition = this.chartCanvas.nativeElement.getBoundingClientRect();
              const cursorPosition = {
                x: mouseEvent.clientX - canvasPosition.left,  // Mouse X relative to the canvas
                y: mouseEvent.clientY - canvasPosition.top    // Mouse Y relative to the canvas
              };
              tooltipElement.style.left = (cursorPosition.x + 15) + 'px';
              tooltipElement.style.top = (cursorPosition.y + 15) + 'px';
              // console.log('Cursor Position:', cursorPosition);
            } else {
              this.chartCanvas.nativeElement.style.cursor = 'default';
            }
          }
        },
        plugins: [{
          id: 'doughnutCenterText', // Unique ID for the plugin
          afterDraw: (chart) => {
            const ctx = chart.ctx;
            const width = chart.width;
            const height = chart.height;
            const fontSize = (height / 114).toFixed(2); // Size of the font
            const total = data.reduce((acc, item) => acc + item, 0);
            // const formattedTotal = total.toLocaleString()
            // const formattedTotal = formatNumber(total)
            const formattedTotal = formatIndianNumber(total)
            // Set the style for the text
            if (total > 0) {
              // Set the style for the text
              ctx.save();
              ctx.font = "800 22px Lato"
              ctx.fillStyle = '#000'; // Color of the text
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
        
              // Draw the total in the center
              ctx.fillText(formattedTotal, width / 2, height / 2);
              ctx.restore();
            }
          }
        }]   
      }) 
    }
  }

  private destroyChart(): void {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = undefined;
    }
  }
}
